import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BranchTableViewModel } from 'src/app/shared/models/autogenerated-piping';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export interface BranchDictionaryModalData {
  excludeIds: string[];
  existingTables?: BranchTableViewModel[];
}

@Component({
  selector: 'app-branch-dictionary-modal',
  templateUrl: './branch-dictionary-modal.component.html',
  styleUrls: ['./branch-dictionary-modal.component.scss'],
  standalone: false
})
export class BranchDictionaryModalComponent implements OnInit {
  faXmark = faXmark;
  selectedTables: BranchTableViewModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<BranchDictionaryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BranchDictionaryModalData
  ) {}

  ngOnInit(): void {
  }

  onTableSelectionChange(tables: BranchTableViewModel[]): void {
    this.selectedTables = tables;
  }

  confirmSelection(): void {
    this.dialogRef.close(this.selectedTables);
  }

  close(): void {
    this.dialogRef.close();
  }
}
